import { Avatar, Box, CardHeader, CircularProgress, Divider, Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { formatPhone } from "../../App/Utilities/formatUtilities";
import { useMessagesContext } from "../State/MessagesContext";
import { candidateInitials } from "../Utils";

export default function CandidateMessageContainer({
  children,
  headerComponents,
}: {
  children: React.ReactNode;
  headerComponents?: React.ReactNode | undefined;
}) {
  const { selectedCandidate } = useMessagesContext();
  return (
    <Box
      sx={{
        minHeight: {
          lg: 650,
        },
        height: "100%",
        width: "100%",
        border: "#ccc 1px solid",
        borderRadius: 1,
        p: 1,
      }}
    >
      {selectedCandidate ? (
        <>
          <Stack direction="column" alignItems="stretch" sx={{ height: "100%" }}>
            <Stack direction="row" sx={{ width: "100%" }} justifyContent={"space-between"}>
              <CardHeader
                data-test={"selected-candidate-header"}
                component={Link}
                to={`/candidates/${selectedCandidate.id}`}
                target="_blank"
                sx={{
                  textDecoration: "none",
                  "&:focus, &:hover, &:visited, &:link, &:active": {
                    textDecoration: "none",
                    color: "inherit",
                  },
                }}
                avatar={<Avatar>{candidateInitials(selectedCandidate)}</Avatar>}
                title={
                  <Typography sx={{ fontWeight: 600 }}>
                    {selectedCandidate
                      ? `${selectedCandidate?.firstName} ${selectedCandidate?.lastName}`
                      : "Select a candidate"}
                  </Typography>
                }
                subheader={
                  <Typography sx={{ fontWeight: 500, fontSize: 12 }}>
                    {selectedCandidate
                      ? selectedCandidate?.emailAddresses
                          .map((c) => c.emailAddress)
                          .concat(selectedCandidate?.phoneNumbers.map((c) => formatPhone(c.phoneNumber)))
                          .join(", ")
                      : ""}
                  </Typography>
                }
              />
              {headerComponents}
            </Stack>
            <Divider />
            {children}
          </Stack>
        </>
      ) : (
        <Box
          sx={{
            minHeight: 300,
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Box>
      )}
    </Box>
  );
}
